import React, {useCallback, useEffect, useState} from 'react';

import Category from './Category';

const filterKey = (category, value) => [category, value].join();

const Categories = props => {
    const {event, filterParams} = props,
        categories = filterParams?.categories || {},
        [usedFilters, setUsedFilters] = useState([]);

    useEffect(() => {
        let nextUsedFilters = usedFilters;
        for (let category in categories) {
            for (let value of categories[category]) {
                let key = filterKey(category, value);
                if (!nextUsedFilters[key]) {
                    nextUsedFilters = {
                        ...nextUsedFilters,
                        [key]: {key, category, value},
                    };
                }
            }
        }
        setUsedFilters(nextUsedFilters);
    }, [categories]);

    const handleFilterRemoved = useCallback(
        (category, value) => {
            let key = filterKey(category, value),
                nextUsedFilters = {...usedFilters};
            delete nextUsedFilters[key];
            setUsedFilters(nextUsedFilters);
        },
        [usedFilters]
    );

    return Object.values(usedFilters).map((filter, i) => (
        <Category event={event} filterParams={filterParams} {...filter} onFilterRemoved={handleFilterRemoved} />
    ));
};

export default Categories;
